<template>
    <div class="main-404 am-text-center">
        <h4 class="am-text-xl">Erro：404 Page Not Found</h4>
        <img src="../assets/icons/404.png" >
        <div class="am-text-xs">
            <p>抱歉，無法訪問您要查找的頁面。 請檢查網絡，</p>
            <p>請檢查網絡
                <router-link to="/">前往首頁</router-link>，或向管理员<a href="">上傳</a>此問題。</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "404"
    }
</script>

<style scoped>

    /* 404页面 */
    .main-404{
        margin: 0 auto;
        padding: 0.64rem 0;
    }
    .am-text-center {
         text-align: center;
    }
    .main-404 img{
        width: 4.38rem;
        height: 1.63rem;
        margin: 0.54rem 0;
    }
    .main-404 div p{
        line-height: 0.2rem;
    }
    .am-text-xl{
        font-size: 0.24rem;
    }
    .am-text-xs{
        font-size: 0.12rem;
    }
</style>